import { Component } from '@angular/core';
import { AlertController, NavController, NavParams, ViewController } from 'ionic-angular';
import { FormGroup } from "@angular/forms";
import { ApiService } from "../../services/api.service";
import { ReportCustomerClientPage } from "../report-customer-client/report-customer-client";
import { BarcodeScanner } from "@ionic-native/barcode-scanner";

@Component({
  selector: 'page-report-search-location',
  templateUrl: 'report-search-location.html',
})
export class ReportSearchLocationPage {

  searchPerformed = false;
  busy = false;
  clientForm: FormGroup;
  locationForm: FormGroup;
  invoiceForm: FormGroup;
  externalForm: FormGroup;
  page: ReportCustomerClientPage;
  data: any;

  searchType = 1;
  query = '';
  zipcode = '';
  number = '';
  locations = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public alertCtrl: AlertController,
    public barcodeScanner: BarcodeScanner,
    public apiService: ApiService
  ) {
    this.clientForm = navParams.get('clientForm');
    this.locationForm = navParams.get('locationForm');
    this.invoiceForm = navParams.get('invoiceForm');
    this.externalForm = navParams.get('externalForm');
    this.page = navParams.get('page');
    this.data = navParams.get('data');
    // Set search type
    let user = this.apiService.getLoggedInUser();
    if(parseInt(user.search_type) === 2 || parseInt(user.search_type) === 3){
      this.searchType = parseInt(user.search_type);
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReportSearchLocationPage');
  }

  isValid(){
    if(
      (this.searchType === 1 && this.query.trim()) ||
      (this.searchType === 2 && this.zipcode.trim() && this.number.trim()) ||
      (this.searchType > 2 && this.searchType < 9 && this.query.trim())
    ){
      return true;
    }
    return false;
  }

  scanBarcode(){
    this.barcodeScanner.scan({
      showTorchButton: true,
      torchOn: true
    }).then(data => {
      console.log('Barcode data', data);
      let barcode = data.text;
      if(barcode.lastIndexOf('/') > 0) {
        barcode = barcode.substring(barcode.lastIndexOf('/') + 1);
      }
      if(barcode){
        this.query = barcode;
        this.search(3);
      }
    }).catch(err => {
      console.log('Error', err);
    });
  }

  search(searchType?){
    if(!searchType){
      searchType = this.searchType;
    }
    if(!this.isValid()){
      return;
    }
    this.searchPerformed = false;
    this.locations = [];
    this.busy = true;
    this.apiService.searchLocation(this.query, this.zipcode, this.number, searchType).then((data) => {
      // @ts-ignore
      this.locations = data;
      this.busy = false;
      this.searchPerformed = true;
    }).catch((error_code) => {
      this.busy = false;
      this.searchPerformed = true;
      let msg = 'Er is iets mis gegaan bij het communiceren met de server. Controleer uw internetverbinding.';
      if(error_code < 0) msg = 'Er is iets mis gegaan bij het communiceren met de server (' + (error_code * -1) + ')';
      this.alertCtrl.create({
        title: 'Fout',
        message: msg,
        buttons: ['OK']
      }).present();
    });
  }

  select(location){
    console.log(location);
    location._same_as_client = 0;
    location._requires_action = '0';
    this.page.locationExpanded = true;
    this.locationForm.patchValue(location);
    this.locationForm.markAsPristine();
    if(location.customers && location.customers.client){
      location.customers.client._requires_action = '1';
      if(location.customers.client.terms_agreed && location.customers.client.terms_agreed === '1'){
        location.customers.client.terms_agreed = true;
      }
      this.clientForm.patchValue(location.customers.client);
      this.page.clientRequiresAction = '1';
      this.clientForm.markAsPristine();
    }
    if(location.customers && location.customers.invoice){
      location.customers.invoice._requires_action = '1';
      this.invoiceForm.patchValue(location.customers.invoice);
      this.page.invoiceExpanded = true;
      this.invoiceForm.markAsPristine();
    }
    if(location.customers && location.customers.external){
      location.customers.external._requires_action = '1';
      this.externalForm.patchValue(location.customers.external);
      this.page.externalExpanded = true;
      this.externalForm.markAsPristine();
    }
    // Set selected_unit unit als gezocht is op QR code
    if(location.units && location.units.length > 0){
      let selected_unit = null;
      for(let j = 0; j < location.units.length; j++){
        let unit = location.units[j];
        let selected = false;
        if(unit.passport_nr == this.query && selected_unit == null){
          selected = true;
          selected_unit = unit;
        }
        location.units[j]._selected = selected;
      }
      if(selected_unit != null){
        this.data._selected_unit = selected_unit;
      }
    }
    this.data.location = location;
    this.data.customers = location.customers;
    this.data._selected_location = location;
    this.data._selected_customers = location.customers;
    this.closeModal();
  }

  closeModal(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-search-location/report-search-location.ts